// @flow
export { default } from './ModalWrapper';



// WEBPACK FOOTER //
// ./src/components/common/ModalWrapper/index.js